//   $('.home-page-slider1').slick({
//     infinite: true,
//     slidesToShow: 4,
//     slidesToScroll: 1,
//     autoplay:false,
//     dots:true,
//     arrows: false,
//     responsive: [
//       {
//         breakpoint: 769,
//         settings: {
//           arrows: true,
//           slidesToShow: 3
//         }
//       },
//       {
//         breakpoint: 768,
//         settings: {
//         autoplay:true,
//           arrows: true,
//           slidesToShow: 1
//         }
//       }
//     ]
//   });

$('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow:'<svg class="prod_slider_prev" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-caret" fill="none" viewBox="0 0 24 15"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 15c-.3 0-.6-.1-.8-.4l-11-13C-.2 1.2-.1.5.3.2c.4-.4 1.1-.3 1.4.1L12 12.5 22.2.4c.4-.4 1-.5 1.4-.1.4.4.5 1 .1 1.4l-11 13c-.1.2-.4.3-.7.3z" fill="currentColor"></path></svg>',
    nextArrow:'<svg class="prod_slider_next" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-caret" fill="none" viewBox="0 0 24 15"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 15c-.3 0-.6-.1-.8-.4l-11-13C-.2 1.2-.1.5.3.2c.4-.4 1.1-.3 1.4.1L12 12.5 22.2.4c.4-.4 1-.5 1.4-.1.4.4.5 1 .1 1.4l-11 13c-.1.2-.4.3-.7.3z" fill="currentColor"></path></svg>',
    asNavFor: '.slider-nav'
});
$('.slider-nav').slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    dots: false,
    focusOnSelect: true,
    verticalSwiping:true,
    prevArrow:'<svg class="prod_slider_prev" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-caret" fill="none" viewBox="0 0 24 15"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 15c-.3 0-.6-.1-.8-.4l-11-13C-.2 1.2-.1.5.3.2c.4-.4 1.1-.3 1.4.1L12 12.5 22.2.4c.4-.4 1-.5 1.4-.1.4.4.5 1 .1 1.4l-11 13c-.1.2-.4.3-.7.3z" fill="currentColor"></path></svg>',
    nextArrow:'<svg class="prod_slider_next" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-caret" fill="none" viewBox="0 0 24 15"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 15c-.3 0-.6-.1-.8-.4l-11-13C-.2 1.2-.1.5.3.2c.4-.4 1.1-.3 1.4.1L12 12.5 22.2.4c.4-.4 1-.5 1.4-.1.4.4.5 1 .1 1.4l-11 13c-.1.2-.4.3-.7.3z" fill="currentColor"></path></svg>'
});

function openCity(evt, cityName, slider) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  setTimeout(function () {
    $(slider).slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      dots: false,
      arrows: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            arrows: true,
            slidesToShow: 1,
            centerMode: false,
            slidesToShow: 1,
          },
        },
      ],
    });
  }, 200);
  document.getElementById(cityName).style.display = "block";
  evt.currentTarget.className += " active";
}

$(".inner-tab-slider1").slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: false,
  dots: false,
  arrows: true,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: true,
        slidesToShow: 1,
        centerMode: false,
        slidesToShow: 1,
      },
    },
  ],
});


function playVid(videoId) {
  // $(".vide-block video").each(function () {
  //   // Pause each video element
  //   this.pause();
  // });
  let str = videoId;
  str = str.substring(1);
  var video = $("#" + str);

  // Detect play/pause state of video and toggle
  if (video.get(0).paused) {
    video.get(0).play();
  } else {
    video.get(0).pause();
  }
  $("#" + videoId)
    .find("button")
    .toggle("hideDiv");
}

function openCity2(evt, cityName) {
      var i, tabcontent2, tablinks2;
      tabcontent2 = document.getElementsByClassName("tabcontent2");
      for (i = 0; i < tabcontent2.length; i++) {
        tabcontent2[i].style.display = "none";
      }
      tablinks2 = document.getElementsByClassName("tablinks2");
      for (i = 0; i < tablinks2.length; i++) {
        tablinks2[i].className = tablinks2[i].className.replace(" active", "");
      }
      document.getElementById(cityName).style.display = "block";
      evt.currentTarget.className += " active";
    }

var acc = document.getElementsByClassName("custom_accordion");
    var i;
    
    for (i = 0; i < acc.length; i++) {
      acc[i].addEventListener("click", function() {
        this.classList.toggle("active");
        var panel = this.nextElementSibling;
        if (panel.style.maxHeight) {
          panel.style.maxHeight = null;
        } else {
          panel.style.maxHeight = panel.scrollHeight + "px";
        } 
      });
    }

let isMouseDown = false;
let startX;
let scrollLeft;
const scrollable = document.getElementById("scrollable");

if (scrollable) {
scrollable.addEventListener("mousedown", (e) => {
  isMouseDown = true;
  startX = e.pageX - scrollable.offsetLeft;
  scrollLeft = scrollable.scrollLeft;
});

scrollable.addEventListener("mouseup", () => {
  isMouseDown = false;
});

scrollable.addEventListener("mousemove", (e) => {
  if (!isMouseDown) return;
  e.preventDefault();
  const x = e.pageX - scrollable.offsetLeft;
  const walk = (x - startX) * 2; // Adjust the scroll speed here
  scrollable.scrollLeft = scrollLeft - walk;
});
}

$('.adev-media__inner-main').slick({
  asNavFor: '.apm-tc'
});
$('.apm-tc').slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  asNavFor: '.adev-media__inner-main',
  centerMode: true,
  focusOnSelect: true
}); 


// $(".custom_accordion").click(function() {
//   alert("aa");
//  this.classList.toggle("active");
//         var panel = this.nextElementSibling;
//         if (panel.style.maxHeight) {
//           panel.style.maxHeight = null;
//         } else {
//           panel.style.maxHeight = panel.scrollHeight + "px";
//         } 
// });

